/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type HelpInfo_viewer$ref = any;
type NextStatusComparison_viewer$ref = any;
type PointsSummary_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TpnOverview_viewer$ref: FragmentReference;
export type TpnOverview_viewer = {|
  +$fragmentRefs: HelpInfo_viewer$ref & NextStatusComparison_viewer$ref & PointsSummary_viewer$ref,
  +$refType: TpnOverview_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TpnOverview_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "HelpInfo_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "NextStatusComparison_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PointsSummary_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '22880fe87e5850c6ce916735c79e08d5';
module.exports = node;
